import { Button } from "../ui/Button.jsx";

export function Cta() {
  return (
    <section className="cta" id="cta">
      <div className="container">
        <div className="ctaCard" data-reveal>
          <div className="ctaLeft">
            <h2 className="h2">Остались вопросы?</h2>
            <p className="muted">
              Если вы хотите создать личный кабинет автора или вам пришло уведомлении о нарушении, напишите и наши эксперты вам помогут.
            </p>
          </div>
          <div className="ctaRight">
            <form
              className="form"
              onSubmit={(e) => {
                e.preventDefault();
                alert("Демо: отправка формы отключена. Можно подключить API.");
              }}
            >
              <label className="field">
                <span className="fieldLabel">Email</span>
                <input className="input" type="email" required placeholder="you@company.com" />
              </label>
              <label className="field">
                <span className="fieldLabel">Компания</span>
                <input className="input" type="text" placeholder="Inilaw" />
              </label>
              <Button>Отправить</Button>
              <div className="fine muted">Нажимая “Отправить”, вы соглашаетесь с обработкой данных.</div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

